export default __webpack_public_path__ + "static/media/FavoriteOuline.97000526.svg";